// src/components/dashboard/SuperadminErrorRate.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent } from '../ui/card';
import { AlertTriangle } from 'lucide-react';

function SuperadminErrorRate() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchErrorRate = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/superadmin-stats/error-rate`, {
          withCredentials: true,
        });
        setData(res.data);
      } catch (error) {
        console.error('Fehler beim Abrufen der Fehlerquote:', error);
      }
    };
    fetchErrorRate();
  }, []);

  if (!data) return null;

  const { errors, total } = data;
  const rate = total > 0 ? ((errors / total) * 100).toFixed(2) : '0.00';
  const statusColor = rate > 10 ? 'text-red-500' : rate > 5 ? 'text-yellow-400' : 'text-green-400';

  return (
    <Card className="h-full">
      <CardContent className="p-6 flex items-center gap-4">
        <AlertTriangle size={32} />
        <div>
          <p className="text-gray-400 text-sm">Fehlerquote (7 Tage)</p>
          <p className={`text-2xl font-bold ${statusColor}`}>{rate}%</p>
          <p className="text-xs text-gray-500">
            {errors} von {total} Anfragen fehlerhaft
          </p>
        </div>
      </CardContent>
    </Card>
  );
}

export default SuperadminErrorRate;
